import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ShowcasePageBlockCtaDto } from './ShowcasePageBlockCtaDto'
/**
* Class ShowcasePageBlockBannerDto
*  Опубликованный баннер витрины.
*/
export class ShowcasePageBlockBannerDto extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'Banner' })
  readonly type: string = 'Banner'


/**
  * key
  * Ключ слота; уникален в рамках канала среди неудалённых.<br>Задаётся оператором; шаблон витрины запрашивает блок по этому ключу.<br>
  */
  @ActiveField('')
  key: string = ''


/**
  * imageId
  * Изображение баннера.
  */
  @ActiveField()
  imageId?: string


/**
  * title
  * Заголовок; null — шаблон не рисует заголовок.
  */
  @ActiveField()
  title?: null | string


/**
  * teaser
  * Тизер, один абзац plain text; null — абзац не рисуется.
  */
  @ActiveField()
  teaser?: null | string


  /**
  * cta
  * Опциональная кнопка / ссылка.  */
  @ActiveField({
    factory: [ShowcasePageBlockCtaDto, () => undefined]
  })
  cta?: null | ShowcasePageBlockCtaDto
}
